import { render, staticRenderFns } from "./EditNewOrdersTree.vue?vue&type=template&id=31b33f0c&scoped=true"
import script from "./EditNewOrdersTree.vue?vue&type=script&lang=js"
export * from "./EditNewOrdersTree.vue?vue&type=script&lang=js"
import style0 from "./EditNewOrdersTree.vue?vue&type=style&index=0&id=31b33f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b33f0c",
  null
  
)

export default component.exports